import { render, staticRenderFns } from "./hrd-new-trainee-detail.vue?vue&type=template&id=54ca7b52"
import script from "./hrd-new-trainee-detail.vue?vue&type=script&lang=js"
export * from "./hrd-new-trainee-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports